import { render, staticRenderFns } from "./account.vue?vue&type=template&id=6ce036b5&scoped=true"
import script from "./account.vue?vue&type=script&lang=js"
export * from "./account.vue?vue&type=script&lang=js"
import style0 from "./account.vue?vue&type=style&index=0&id=6ce036b5&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce036b5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/private/workspaces/smart-life/smart-life-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ce036b5')) {
      api.createRecord('6ce036b5', component.options)
    } else {
      api.reload('6ce036b5', component.options)
    }
    module.hot.accept("./account.vue?vue&type=template&id=6ce036b5&scoped=true", function () {
      api.rerender('6ce036b5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ShopDetail/account.vue"
export default component.exports